export default __webpack_public_path__ + "static/media/banner-1.5275f7ab.png";